module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.users) ? _c('user-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usersPageCount > 1),
      expression: "usersPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "usersPaginate",
    attrs: {
      "pageCount": _vm.usersPageCount,
      "initial-page": 0,
      "clickHandler": _vm.usersPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingUsers
    },
    on: {
      "click": function($event) {
        _vm.usersPaginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingUsers
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('user.list.search')))]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": _vm.$t('user.list.search.description')
    }
  }, [_c('typeahead', {
    ref: "userSearchTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.userSelected
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c1d7daf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserList.vue
// module id = 506
// module chunks = 0